import * as angular from 'angular';
import * as moment from 'moment';

import { IDateRangePickerOptions, IFrequency, TimeUnit } from '../../models';
import { IDateHelperFormatService, IDateNavigationService } from './';
import { ICurrentApplicationService } from '../data';
import { getFreq } from './getDefaultFreq';

type PredefinedRanges = { [key: string]: [moment.Moment, moment.Moment] };

export interface IDateRangeOptionsBuilder {
    getDefaultOptions(frequency?: IFrequency, isLimited?: boolean, isSingle?: boolean): angular.IPromise<IDateRangePickerOptions>;
    translate(options: IDateRangePickerOptions): IDateRangePickerOptions;
}

export class DateRangeOptionsBuilder implements IDateRangeOptionsBuilder {
    static serviceId: string = 'dateRangeOptionsBuilder';
    static $inject = [
        '$translate',
        'currentApplicationService',
        'dateNavigationService',
        'dateHelperFormatService'
    ];
    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _currentApplicationService: ICurrentApplicationService,
        private _dateNavigationService: IDateNavigationService,
        private _dateFormatHelperService: IDateHelperFormatService
    ) {
    }

    getDefaultOptions(frequency?: IFrequency, isLimited?: boolean, isSingle?: boolean): angular.IPromise<IDateRangePickerOptions> {
        const config = this._currentApplicationService.getApplicationConfiguration();
        const freq = getFreq(config, frequency);
        return this.createRanges(freq.intervalTimeUnit, isLimited)
            .then(ranges => {
                let options: IDateRangePickerOptions = {
                    applyClass: 'btn-primary',
                    timePicker24Hour: true,
                    timePicker: this._dateFormatHelperService.hasHour(freq),
                    timePickerIncrement: this.getIncrement(freq),
                    alwaysShowCalendars: true,
                    showDropdowns: true,
                    locale: {
                        applyLabel: 'Refresh',
                        fromLabel: 'Start date',
                        format: 'YYYY-MM-DD HH:mm',
                        toLabel: 'End date',
                        cancelLabel: 'Cancel',
                        customRangeLabel: 'Custom range',
                        firstDay: !!config ? config.weekBeginDay : 0
                    },
                    ranges: isSingle ? undefined : ranges,
                    singleDatePicker: isSingle
                };

                options = this.translate(options);
                return options;
            })
            .catch(reason => {
                console.error(reason);
                return {};
            });
    }


    private getIncrement(freq: IFrequency): number {
        return (freq.intervalTimeUnit === TimeUnit.Minute)
            ? freq.interval
            : 60;
    }

    private createRanges(timeUnit: TimeUnit, isLimited: boolean): angular.IPromise<PredefinedRanges> {
        return this._dateNavigationService.getKeywordDates(timeUnit, isLimited)
            .then(data => {
                const result = {};
                data.forEach(range => {
                    result[range.keyword] = [moment(range.beginDateTime), moment(range.endDateTime)];
                });
                return result;
            })
            .catch(reason => {
                console.error(reason);
                return {};
            });
    }

    translate(options: IDateRangePickerOptions): IDateRangePickerOptions {
        //return options;
        const newOptions = angular.copy(options);
        if (this._$translate.use()) {
            if (newOptions.ranges) {
                const result = newOptions.ranges;
                const translated = {};
                for (const key of Object.keys(result)) {
                    const label = this._$translate.instant(key);
                    translated[label] = result[key];
                }
                newOptions.ranges = translated;
            }
            if (newOptions.locale) {
                for (const key of Object.keys(newOptions.locale)) {
                    if (key.indexOf('Label') >= 0) {
                        newOptions.locale[key] = this._$translate.instant(newOptions.locale[key]);
                    }

                }
                newOptions.locale.daysOfWeek = moment.weekdaysMin() as [string, string, string, string, string, string, string];
            }
        }
        return newOptions;
    }
}